import React, { useEffect } from 'react';
import { useStatusContext } from '../context/StatusContext';
import { useUserContext } from '../context/UserContext';
import { useArchiveContext } from '../context/ArchiveContext';
import { faBoxArchive, faRotateLeft, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ArchivePage = () => {
    const { archive, fetchArchive, deleteArchive, returnArchive, updateArchive } = useArchiveContext();
    const { users } = useUserContext();
    const { status } = useStatusContext();

    useEffect(() => {
      fetchArchive();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const upd = (task) => {
      const id = task._id;
      updateArchive(task, id);
    };

    const getStatusName = (statusId) => {
      const s = status?.find(st => st._id === statusId);
      return s ? s.name : '—';
    };

    const getUserName = (userId) => {
      const u = users?.find(u => u._id === userId);
      return u ? u.name : '—';
    };

    const formatDate = (ts) => {
      if (!ts) return '';
      const d = new Date(ts);
      if (isNaN(d)) return '';
      return `${String(d.getDate()).padStart(2,'0')}.${String(d.getMonth()+1).padStart(2,'0')}.${d.getFullYear()} ${String(d.getHours()).padStart(2,'0')}:${String(d.getMinutes()).padStart(2,'0')}`;
    };

    return (
      <div className="crm-page">
        {/* Breadcrumb */}
        <div className="crm-breadcrumb">
          <span className="crm-breadcrumb__item">Рабочий стол</span>
          <span className="crm-breadcrumb__sep">›</span>
          <span className="crm-breadcrumb__item crm-breadcrumb__item--active">Архив</span>
        </div>

        {/* Заголовок */}
        <div className="crm-page-header">
          <h1 className="crm-page-title">
            <FontAwesomeIcon icon={faBoxArchive} style={{ marginRight: 10, fontSize: 20, color: '#7c3aed' }} />
            Архив
          </h1>
          <span className="archive-count">Записей: {archive?.length ?? 0}</span>
        </div>

        {/* Грид карточек */}
        <div className="archive-grid">
          {!archive?.length && (
            <div className="archive-empty">Архив пуст</div>
          )}

          {archive?.map(task => (
            <div key={task._id} className="archive-card">
              <div className="archive-card__header">
                <span className="archive-card__title">{task.name}</span>
              </div>

              {task.createDate && (
                <div className="archive-card__date">{formatDate(task.createDate)}</div>
              )}

              {task.description && (
                <p className="archive-card__desc">
                  {task.description.slice(0, 120)}{task.description.length > 120 ? '…' : ''}
                </p>
              )}

              {/* <div className="archive-card__field">
                <span className="archive-card__field-label">Исполнитель</span>
                <select
                  className="crm-card__executor-select"
                  value={task.executor}
                  onChange={(e) => upd({ ...task, executor: e.target.value })}
                >
                  {users?.map(user => (
                    <option key={user._id} value={user._id}>{user.name}</option>
                  ))}
                </select>
              </div> */}

              <div className="archive-card__field">
                <span className="archive-card__field-label">Исполнители</span>
                <div className="crm-card__executors">
                  {(task.executors || (task.executor ? [task.executor] : [])).map((uid) => (
                    <span key={uid} className="crm-card__executor-badge">{getUserName(uid)}</span>
                  ))}
                </div>
              </div>

              <div className="archive-card__field">
                <span className="archive-card__field-label">Статус</span>
                <select
                  className="crm-card__status-select"
                  value={task.status}
                  onChange={(e) => upd({ ...task, status: e.target.value })}
                >
                  {status?.map(statu => (
                    <option key={statu._id} value={statu._id}>{statu.name}</option>
                  ))}
                </select>
              </div>

              <div className="archive-card__actions">
                <button
                  className="archive-card__btn archive-card__btn--return"
                  onClick={() => returnArchive(task, task._id)}
                  title="Вернуть в работу"
                >
                  <FontAwesomeIcon icon={faRotateLeft} />
                  <span>Вернуть</span>
                </button>
                <button
                  className="archive-card__btn archive-card__btn--delete"
                  onClick={() => deleteArchive(task._id)}
                  title="Удалить навсегда"
                >
                  <FontAwesomeIcon icon={faTrash} />
                  <span>Удалить</span>
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
};

export default ArchivePage;